/**
 * Handles {@link com.inq.flash.client.data.MessageFields.TYPE_AUTHENTICATED_USER_RESPONSE} message.
 * <p> Converts sync chat to async on customer authorization when chat was converted to async on server side and conversation was created.
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this, com.inq.flash.client.data.MessageFields.TYPE_AUTHENTICATED_USER_RESPONSE);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler, com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler, "com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler");

/**
 * processMessage
 * <p> Converts chat to async if required, requests conversation transcript on this action as well
 */
com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler.prototype.processMessage = function(message) {
	//if chat is already async then do nothing
	if (this.getController().getChat().isAsyncChat()) {
		return;
	}

	var conversationId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CONVERSATION_ID);
	var asyncEngagement = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_CONFIG_IS_ASYNC_ENGAGEMENT);
	if (asyncEngagement) {
		this.getController().getChat().setAsyncChat(asyncEngagement);
		com.inq.flash.client.control.FlashPeer.setAsyncChat(asyncEngagement);
		com.inq.flash.client.control.FlashPeer.getConversationTranscript(function() {
			com.inq.flash.client.chatskins.SkinControl.asyncTranscriptLoading = false;
		});
		com.inq.flash.client.control.PersistenceManager.SetValue(CONVERSATION_ID, conversationId);
		com.inq.flash.client.control.FlashPeer.fireCustomerAuthenticatedEvent();
	}
};

/** @type {com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler} */
com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.AuthenticatedUserResponseMessageHandler;
